import React, { useState } from 'react';
import './Login.css';
import authAPI from '../api/auth';

function LoginAPI({ onLogin }) {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    // Prosta walidacja
    if (!formData.email || !formData.password) {
      setError('Proszę wypełnić wszystkie pola');
      setLoading(false);
      return;
    }

    try {
      // Próba logowania przez API
      const response = await authAPI.login(formData.email, formData.password);
      
      if (response.user && response.token) {
        onLogin({
          email: response.user.email,
          name: response.user.name,
          role: response.user.role,
          id: response.user.id,
          projects: response.user.projects || [],
          permissions: response.user.permissions || {} // WAŻNE: Przekaż uprawnienia z odpowiedzi serwera
        });
      }
    } catch (err) {
      // W produkcji NIE używaj trybu demo - zawsze wymagaj backend API
      setError(err.message || 'Nieprawidłowe dane logowania. Sprawdź czy backend działa.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Logowanie</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="twoj@email.pl"
              autoComplete="off"
              required
              disabled={loading}
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Hasło:</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="••••••••"
              autoComplete="off"
              required
              disabled={loading}
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Logowanie...' : 'Zaloguj się'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginAPI;



